<template>
    <PopupRouterViewDetail label="Part Price Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Part Price" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="false" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" :isEditable="false"/>
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.part != null) ? model.part.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.part != null) ? (model.part.partClassification != null) ? model.part.partClassification.code : null : null"  />
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="getCustomerCodeName()"  />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor-id" size="sm" :model.sync="model.vendorIdId"  :isRequired="false" :state="validateState('vendorIdId')" :errorMessage="getErrorMessage(errorMessage.vendorIdId, 'vendorIdId')"  :selected="model.vendorId != null ? model.vendorId.code : ''" @input="getVendors"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorId" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox-custom id="fieldset-price-process" label-cols-lg="12" label="Price Process" label-for="input-price-process" size="sm" :thousandSeparator="true" :model.sync="model.priceProcess"  :isEditable="false" :isUpdatable="false" />
						<app-input-textbox-custom id="fieldset-price-product" label-cols-lg="12" label="Price Product" label-for="input-price-product" size="sm" :thousandSeparator="true" :model.sync="model.priceProduct"  :isEditable="false" :isUpdatable="false" />
						<app-input-datepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="model.startDate" :isRequired="false" :state="validateState('startDate')" :errorMessage="getErrorMessage(errorMessage.startDate, 'startDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="true" :isEditable="false"/>
						<app-input-datepicker id="fieldset-end-date" label-cols-lg="12"  label="End Date" size="sm" :model.sync="model.endDate"  :date-format-options="model.endDate == null ? '' : { year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false"  :isUpdatable="true" :notUseDefaultValue="true"/>
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->
		<template #modal-left-button>
			<b-button v-if="isShowEditButton" @click="editAction()" size="sm" class="float-right" variant="primary">
              Edit Data
            </b-button>
        </template>

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartPrice from '@/models/PartPrice/PartPrice';
import PartPriceList from '@/models/PartPrice/PartPriceList';
import PartPriceFilter from '@/filters/PartPrice/PartPriceFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PopupRouterViewDetail,
		PopupRouterView,
		AppInputTextboxCustom,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partId: {required},
			startDate: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partId: { required : "Part is Required."},
				startDate: { required : "Start Date is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPartPrice : null,
			currentPartPricePage : 1,
			partPricePageSize: 10,
			sortByPartPrice: '',
			sortDescPartPrice: '',
			parts: [],
			parts: [],
			isPartComboLoading: false,
			vendors: [],
			vendorIds: [],
			isVendorIdComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isVendorComboLoading: false,
		}
	},
	methods : {
		getCustomerCodeName() {
			if(this.model != null && this.model.part != null && this.model.part.customer != null) {
				return this.model.part.customerCode + " - " + this.model.part.customer.name
			}
			return "";
		},
		editAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'partpricecreate', params : { id: id } });
			}
		},
		getPartPrice : async function(id) {
			this.isBusy = true;
			PartPrice.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.partId != null) {
					promises.push(
						this.getPart(this.model.partId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartPrice = true;
			this.filterPartPrice.id = this.modelId;
			PartPrice.downloadDataDetail(this, this.filterPartPrice).then(result => {
				this.isDownloadPartPrice = false;
			}).catch(error => { this.isDownloadPartPrice = false; })
		},
		getPartPrices : async function(input) {
			let filter = new PartPriceFilter();
			if (input != undefined) {
				filter.Part = input;
			}
			this.isPartPriceComboLoading = true;
			PartPrice.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
				}
				this.isPartPriceComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendorId(item) {
			if(item == undefined || item == null) {
				this.model.vendorIdId = null;
				this.model.vendorId = null;
			} else {
				this.model.vendorIdId = item.id;
				this.model.vendorId = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.part = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partPriceInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PartPrice.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partpriceindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PartPrice.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'partpriceindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPrice.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPartPrice(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartPrices();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPartPrice = new PartPriceFilter();
		//this.getParts();
		//this.getVendors();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartPrice(id);
			} else {
				this.modelId = id;
				this.getPartPrice(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		},
		isShowEditButton: {
			get: function() {
				if(this.model.startDate == undefined || this.model.startDate == null) return false;
				if(this.model.endDate != undefined && this.model.endDate != null) return false;
				// if(new Date(this.model.startDate) <= new Date()) return false;
				return true;
			}
		},
	},
	watch : {
	},
}
</script>
